import { SIGN_IN_URL } from '../lib/auth';
import type { AuthState } from '../lib/auth';
import './signin.css';
import { Mark } from './Mark';

/**
 * The sign-in gate.
 *
 * It distinguishes four situations, because they need four different actions:
 * not signed in, signed in but not registered, disabled, and server
 * unreachable. Showing "please sign in" to someone whose account was disabled
 * sends them round the loop forever.
 */
export function SignIn({ state }: { state: AuthState }) {
  const refused = state.status === 'refused';
  const down = state.status === 'unreachable';

  return (
    <main className="signin">
      <div className="signin-art" aria-hidden="true" />
      <div className="signin-panel">
        <div className="signin-inner">
          <div className="signin-brand">
            <Mark size={54} label={false} className="signin-mark" />
            <div>
              <div className="signin-name">205 Holdings</div>
              <div className="signin-place">Tuscaloosa</div>
            </div>
          </div>

          {!refused && !down && (
            <>
              <h1 className="signin-title">Sign in</h1>
              <p className="signin-body">
                One place for Rounders, Two Dimes, The Sandlot and Cocktail Collection —
                and every company behind them.
              </p>
              <a className="signin-button" href={SIGN_IN_URL}>
                <MicrosoftMark />
                Sign in with Microsoft
              </a>
              <p className="signin-fine">
                Access is granted per person. Signing in proves who you are; an
                administrator decides what you can see.
              </p>
            </>
          )}

          {refused && (
            <>
              <h1 className="signin-title">
                {state.error === 'account_disabled' ? 'Account disabled' : 'Not registered'}
              </h1>
              <p className="signin-body">{state.message}</p>
              <a className="signin-button signin-button--quiet" href={SIGN_IN_URL}>
                Try a different account
              </a>
              <p className="signin-fine">
                If you have more than one work account, check you used the right one.
              </p>
            </>
          )}

          {down && (
            <>
              <h1 className="signin-title">Can’t reach the server</h1>
              <p className="signin-body">
                This is not a sign-in problem — the application itself is unreachable.
                <span className="signin-detail">{state.detail}</span>
              </p>
              <button className="signin-button signin-button--quiet" onClick={() => location.reload()}>
                Try again
              </button>
            </>
          )}
        </div>
      </div>
    </main>
  );
}

function MicrosoftMark() {
  return (
    <svg width="17" height="17" viewBox="0 0 23 23" aria-hidden="true">
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  );
}
